import gql from "graphql-tag"

const CREATE_OR_UPDATE_DISCOUNT_CODE_RULE = gql`
  mutation createOrUpdateDiscountCodeRule(
    $id: ID!
    $input: InputCreateOrUpdateDiscountCodeRule!
  ) {
    createOrUpdateDiscountCodeRule(
      id: $id
      discountCodeRule: $input
    ) {
      id
      name
      displayNames {
        languageCode
        translation
      }
      logicRules {
        if
        do
      }
      isActive
      isStackable
      isExclusive
      applyLast
      sortOrder
      conditions {
        type
        id
        triggerQuantity
        identifiers
        thresholds {
          currencyCode
          units
        }
        itemRule {
          tagConditions {
            mode
            key
            values
          }
          excludeDiscountedPrices
          excludeFullPrices
        }
      }
      outcomes {
        type
        id
        subOutcomes {
          triggerQuantity
          discountQuantity
          discountValue {
            type
            percentage
            percentageDecimals
            fixedDiscounts {
              currencyCode
              units
            }
          }
        }
        discountValue {
          type
          percentage
          percentageDecimals
          fixedDiscounts {
            currencyCode
            units
          }
        }
        discountItemRule {
          tagConditions {
            mode
            key
            values
          }
          excludeDiscountedPrices
          excludeFullPrices
        }
        triggerItemRule {
          tagConditions {
            mode
            key
            values
          }
          excludeDiscountedPrices
          excludeFullPrices
        }
        shippingTags
        triggerQuantity
        discountQuantity
        gifts {
          productVariantId
          quantity
        }
        combineItemDiscount
        isRecurrent
      }
      validDateRange {
        from
        to
      }
    }
  }
`

export default CREATE_OR_UPDATE_DISCOUNT_CODE_RULE
